import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CryptoTokenClient } from "../../parentApi";

const client = new CryptoTokenClient(app_uri, axiosClient());

export default client;
